import type { IconName } from '@hotjar/hotsauce';
import type {
  RadioBooleanFilterOperation,
  RadioBooleanFilterValueType,
} from './GenericRadioBooleanType';
import { GenericRadioBooleanDropdown } from './GenericRadioBooleanDropdown';
import { GenericFilter } from '../GenericFilter/GenericFilter';
import type { AbstractSingleFilterPillsProps } from '../../SingleFilterType';

interface GenericRadioBooleanFilterProps
  extends AbstractSingleFilterPillsProps<RadioBooleanFilterValueType> {
  filterName: string;
  iconName: IconName;
  options: RadioBooleanFilterOperation[];
  label1?: string;
  label2?: string;
}

export function GenericRadioBooleanFilter({
  currentValue,
  autoFocus,
  optionalDefaultValue,
  onApply,
  onRemove,
  filterName,
  iconName,
  options,
  label1,
  label2,
  showDropdownOnMount,
  onDropdownHidden,
}: GenericRadioBooleanFilterProps): JSX.Element {
  const handleApply = (close: () => void, newValue?: RadioBooleanFilterValueType) => {
    onApply(newValue);
    close();
  };

  return (
    <GenericFilter
      autoFocus={autoFocus}
      filterName={filterName}
      label1={label1}
      label2={label2}
      iconName={iconName}
      onRemove={onRemove}
      showDropdownOnMount={showDropdownOnMount}
      onDropdownHidden={onDropdownHidden}
      renderDropdown={({ close }) => {
        return (
          <GenericRadioBooleanDropdown
            filterName={filterName}
            currentValue={currentValue}
            optionalDefaultValue={optionalDefaultValue}
            onApply={(newValue) => handleApply(close, newValue)}
            options={options}
          />
        );
      }}
    />
  );
}
